module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("企划经理")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)主持企划部日常管理工作；\n(2)负责公司品牌建设和管理工作，审定各项宣传推广品牌形象的公关活动方案；\n(3)责对下属员工进行业务指导、培训和考核工作；\n(4)负责编制各类宣传推广费用的计划，监控预算执行情况并及时呈报；\n(5)负责主持项目的营销策划、平面制作、宣传推广、媒体选用等工作；\n(6)负责公司形象宣传策划，组织撰写宣传推广文案、广告创意设计等；\n(7)完成领导临时交办的其他任务；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)大专以上学历，25-30岁之间，中文、新闻、营销、广告等相关专业，4年以上相关工作经验；\n(2)具有较强的文字功底，熟悉各类文案写作，掌握企业各类大型活动策划方案；\n(3)熟练使用各种办公软件、PS、AI等设计软件；\n(4)学习能力强，工作积极主动，责任心强，具有良好的沟通技巧及团队协作精神；\n(5)互联网、电商O2O\\B2B\\B2C公司企划经验者优先考虑；")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("市场总监")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)在公司经营战略指导下，全面计划、安排、管理市场部工作；\n(2)制定年度营销策略、营销计划及预算工作；\n(3)根据目标市场，竞争态势，客户需求等调查，及时掌握市场信息；\n(4)负责公司品牌推广及品牌运作，定期组织市场公关、广告宣传、促销等活动；\n(5)撰写市场分析、创意新的盈利模式，策划网站运营，业务拓展和产品销售的综合推广措施；\n(6)根据公司经营方针和部门业务需要，合理设置部门组织结构和岗位，优化业务流程，提高部门工作效率，完成总经理下达的工作任务；\n(7)分析总结竞争对手，行业信息，公司产品信息等调研信息，确定调研结果，为公司的总体战略制定提供相关依据；\n(8)对市场部工作进行指导、监督，协调部门与其他部门的合作关系；\n(9)项目信息系统框架的规划和设计，制定系统规划方案、可执行方案及预算；\n(10)领导安排的其他事宜；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)本科以上学历，电子商务、信息管理、工商管理、市场营销等相关专业；\n(2)5年以上相关工作经验，3年团队管理经验，熟悉互联网、电子商务市场动态；\n(3)熟知网络营销和线下资源紧密结合，五年以上企业管理经验；\n(4)有较强的执行力，能带领团队完成年度销售任务； \n(5)具有敏锐的商业和市场意识，分析问题及解决问题能力强，具有优秀的资源整合能力和业务推进能力；\n(6)拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想； \n(7)擅长撰写各类策划方案，具有优秀的管理能力、逻辑分析能力，富有激情与创意； \n(8)具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任；")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("物流经理")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)负责部门日常物流管理工作，包括：运输、仓储、配送、车辆、单据管理等；\n(2)制定和执行物流部门工作计划，制度规范进行建立、总结和完善；\n(3)监督实施物流体系职责与管理标准，确保存储和配送任务顺利完成；\n(4)控制送货和仓储成本；\n(5)参与制定与控制部门物流、配送及仓储运作预算；\n(6)制定物流解决方案，提升客户满意度；\n(7)定期汇总上报配送中心各项业务及管理报表；\n(8)完成未尽事宜及上级交办的其他工作；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)大专以上学历，25-35岁之间，管理、物流相关专业；\n(2)五年以上物流经理工作经验，有连锁企业或大中型企业物流管理经验优先；\n(3)熟悉连锁业态物流配送业务规程，有丰富的流程管理操作技能；\n(4)学习能力强，工作积极主动，责任心强，具有良好的沟通技巧及团队协作精神； \n(5)熟悉ERP及物流信息管理系统并有实施经验；\n(6)熟悉现代化物流运输模式，熟悉物流O2O、三方物流运作模式，有较强的物流体系规划能力； \n(7)可接受中短期出差；")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("销售经理")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)负责公司电子商务战略规划及策略执行；\n(2)负责年度销售的预测，目标的制定及分解；\n(3)负责市场调研和需求分析；\n(4)搭建公司互联网推广平台和销售渠道,负责网络推广的制定和实施；\n(5)负责相关电子商务平台及网代相关项目的谈判,进度跟进和管理,达成公司网络销售目标；\n(6)组建销售队伍，培训销售人员；\n(7)完成上级领导安排的其他工作；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)专科以上，电子商务,计算机,市场营销等相关专业；\n(2)3年以上相关工作经验，2年团队管理经验，熟悉互联网、电子商务市场动态；\n(3)熟悉互联网营销的运作模式和流程,有同岗位从业经验优先；\n(4)有电子商务运营经验,熟悉B2B的运作和管理,了解搜索引擎优化及网站推广； \n(5)有较强的文字功底,良好的文字表达能力和较强的口语表达能力和沟通能力；\n(6)具有较强的沟通、组织、协调能力和团队管理能力； \n(7)有较强的执行力，能带领团队完成年度销售任务；")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac340768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/join_us/HomeJoinContent.vue
// module id = 169
// module chunks = 1